import $ from 'jquery';

$('body').on('click', '.create-new-category-link', (e) => {
    e.preventDefault();
    $('#new-category-button').click();
});
